import type { RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    redirect: '/admin/dashboard',
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('./views/AdminDashboardView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/studios',
    name: 'admin-studios',
    component: () => import('./views/AdminStudiosView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/studios/:id',
    name: 'admin-studio-detail',
    component: () => import('./views/AdminStudioDetailView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/alerts',
    name: 'admin-alerts',
    component: () => import('./views/AdminAlertsView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/broadcasts',
    name: 'admin-broadcasts',
    component: () => import('./views/AdminBroadcastsView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('./views/AdminUsersView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/users/:id',
    name: 'admin-user-detail',
    component: () => import('./views/AdminUserDetailView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/system',
    name: 'admin-system',
    component: () => import('./views/AdminSystemView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/whatsapp/setup-requests',
    name: 'admin-whatsapp-setup-requests',
    component: () => import('./views/AdminWhatsappSetupRequestsView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/subscription-products',
    name: 'admin-subscription-products',
    component: () => import('./views/AdminSubscriptionProductsView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
  {
    path: '/admin/ai-usage',
    name: 'admin-ai-usage',
    component: () => import('./views/AdminAiUsageView.vue'),
    meta: { requiresAuth: true, skipOnboardingCheck: true, noLayout: true },
  },
]
